import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  selectPermissionUserDetail,
  useResource,
} from '@bom-nextgen-keycloak/web/core';
import { FeaturePage } from '@bom-nextgen-keycloak/web/shared/data-access';
import {
  AttributeList,
  FormAttribute,
  FormSpinner,
  ProtectedRouter,
} from '@bom-nextgen-keycloak/web/shared/ui';
import { useUserDetail2 } from '../../hooks';
import { PARENT_PATH } from '../../shared';

const Attribute: FC = () => {
  const { id = '' } = useParams();
  const { groupId } = useResource();
  const { data, isLoading, updateMutation } = useUserDetail2(id);
  const { isEditAttributesTab: canEdit } = useSelector(
    selectPermissionUserDetail
  );
  const disableField = !canEdit;

  const handleUpdate = (payload: AttributeList) => {
    const email = data?.email ?? '';
    const enabled = data?.enabled ?? false;
    const enabledSSO = data?.enabledSSO ?? false;
    const firstName = data?.firstName ?? '';
    const lastName = data?.lastName ?? '';
    const username = data?.username ?? '';

    if (data) {
      updateMutation.mutate({
        id,
        payload: {
          ...data,
          attributes: { ...payload },
          email,
          enabled,
          enabledSSO,
          firstName,
          groupId,
          lastName,
          username,
        },
      });
    } else {
      // TODO: Implement a handler
    }
  };

  return isLoading ? (
    <FormSpinner />
  ) : (
    <FormAttribute
      disabled={disableField}
      loading={updateMutation.isLoading}
      onSubmit={handleUpdate}
      parentPath={PARENT_PATH}
      values={data?.attributes || {}}
    />
  );
};

const WrappedUserAttributePage: FC = () => {
  const { canViewAttributesTab } = useSelector(selectPermissionUserDetail);

  return (
    <ProtectedRouter
      canView={canViewAttributesTab}
      feature={FeaturePage.USER}
      isEditPage
      navigatePath={PARENT_PATH}
    >
      <Attribute />
    </ProtectedRouter>
  );
};

export { WrappedUserAttributePage };
